// IMPORTANT: This file is auto generated from templates/snippetFile
// Any changes you make to this file here will be overwritten.

import React from 'react';
import Prism from 'prismjs';
import '../../automated-pages-utils/code-snippet-utils/prism.css';
import { CodeWrapper } from '../../automated-pages-utils/code-snippet-utils/Code_SC';
import { DefaultButton, SnackBar, SnackBarProps, FilterButton } from '@inmoment/the-kitchen';

interface Props {
  propObj: Partial<Parameters<typeof FilterButton>[0]>;
  formattingFunction: (propObj: Props['propObj'], name: string) => string;
  lang: string;
}

export const FilterButtonSnippet = (props: Props) => {
  const [snackBarObject, setSnackBarObject] = React.useState<SnackBarProps | null>(null);

  const codeRef = React.useRef<HTMLElement>(null);
  const textArea = React.useRef<HTMLTextAreaElement>(null);

  const { propObj, formattingFunction, lang } = props;

  const code = formattingFunction(propObj, 'FilterButton').trim();

  React.useEffect(() => {
    codeRef.current && Prism.highlightElement(codeRef.current);
  }, [code, lang]);

  const handleCopy = () => {
    textArea.current?.select();
    document.execCommand('copy');
    setSnackBarObject({
      text: 'FilterButton Code Copied!',
      mode: 'default',
      autoDismiss: true,
      actionText: 'Dismiss',
      dismissTime: 2000,
      id: new Date().getTime().toString(),
    });
  };

  return (
    <CodeWrapper>
      <pre className="line-numbers">
        <code ref={codeRef} className={`language-${lang}`}>
          {code}
        </code>
      </pre>
      <div style={{ position: 'absolute', bottom: 24, right: 24 + 282 }}>
        <DefaultButton fill="outline" contrast="high" text="Copy Component Code" onClick={handleCopy} />
      </div>
      <textarea ref={textArea} readOnly style={{ opacity: 0 }} value={code} />
      <SnackBar {...snackBarObject} />
    </CodeWrapper>
  );
};
